import {isProduction} from './EnvVar';

export const AMPLITUDE_KEY = isProduction()
  ? 'd012cf5795de98718af28b8873f86115'
  : 'c6922b85d5fe432a85ed210bdec1ca7a';
